export default __webpack_public_path__ + "static/media/profile.245c1397.jpg";